import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import styles from './style.scss';


const LandingContainer = ({ title, linkText }) => (
  <div className={styles.title}>
    <div className="title-2">{title}</div>
    <div className={styles.link}>
      <span className={classNames('link', styles.linkText)}>{linkText}</span>
      <i className="shortArrow" />
    </div>
  </div>
);

const LandingContentContainer = ({ link, ...props }) => {
  return link
    ? (
      <Link to={link}>
        <LandingContainer {...props} />
      </Link>
    )
    : <LandingContainer {...props} />;
};

LandingContentContainer.propTypes = {
  link: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  title: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
};

export default LandingContentContainer;
